import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Header2 from './header2';
import Menubar from './menubar';
import Footer from './footer';
import { useParams, Link } from 'react-router-dom';

function Design() {
  const productId = useParams();
  const [designs, setDesigns] = useState([]);
  const [products, setProducts] = useState([]);
  const [category, setCategory] = useState({});
  const [showModal, setShowModal] = useState(false);
  const baseURL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {


    const fetchCategory = async () => {

      try {
        const response = await axios.get(`${baseURL}/api/product`);
        setCategory(response.data);
      } catch (err) {
        console.error('Error fetching designs:', err);
      }
    };

    const fetchDesigns = async () => {

      try {
        const response = await axios.post(`${baseURL}/api/design-fetch`, productId);
        setDesigns(response.data);
      } catch (err) {
        console.error('Error fetching designs:', err);
      }
    };

    

    const fetchProduct = async () => {
      try {
        const response = await axios.post(`${baseURL}/api/product-fetch`, productId);
        setProducts(response.data[0]);
      } catch (err) {
        console.error('Error fetching product:', err);
      }
    };
    fetchCategory();
    fetchDesigns();
    fetchProduct();
  }, [productId, baseURL]);

  

  return (
    <>
      <Header2 />
      <div className="container design-container">
        <div>
          <ul className="design-menu">
            <li>
              <Link to={`/`} className="submenu">Home</Link>
            </li>
            <li className="submenu">/</li>
            <li className="submenu active-submenu" style={{cursor:'po'}}>
  <div
    className="hover-wrapper"
    onMouseEnter={() => setShowModal(true)}
    onMouseLeave={() => setShowModal(false)}
    style={{ position: 'relative', display: 'inline-block' }}
  >
    {products.pname}
    {showModal && (
      <div className="modal-tooltip show">
      <div style={{textAlign:'left'}}>
        {
          category.map((cat, index) => (

           <Link to={`/design/${cat.pid}`} style={{color:'black'}}> <p key={index}>  {cat.pname}</p></Link>
          )
       ) }
       
      </div>
      {/* Add more details here if needed */}
    </div>
    )}
  </div>
</li>
          </ul>
        </div>

        <div className="row design-row">
          {designs.map((design) => (
            <div key={design.did} className="col-sm-3 design-sm">
              <div className="design-div-main">
                <Link to={`/design-preview/${design.did}`} className="no-underline">
                  <img
                    src={`${baseURL}/images/${design.image}`}
                    className="design-image"
                    alt={design.dname}
                  />
                  <p className="design-name">{design.dname}</p>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Design;
